
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import FRTBApi from '@/api/frtb.api';

@Component({
  components: {
  },
})
export default class Upgrade extends Vue {

  public selectedNumber: number = -1;
  public comments: string = '';
  public loading: boolean = false;

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public success() {
    this.$store.commit('setToastSuccess', 'Feedback successfully submitted!');
    this.closeModal();
  }

  public error() {
    this.$store.commit('setToastError', 'Error sending feedback. Please try again.');
  }

  public async submitFeedback() {
    this.loading = true;

    try {
      const consented = await FRTBApi.sendFeedback(this.selectedNumber, this.comments);
      this.success();
    } catch (e) {
      this.error();
    }

    this.loading = false;
  }
}

